<template>
  <div class="newsMain">
    <PcWms class="PC"/>
    <MdWms class="MD"/>
  </div>
</template>

<script>
// 移动端
import MdWms from './MdWms.vue'
// pc端
import PcWms from './PcWms.vue'
export default {
  name: 'newsMain',
  components: {
    PcWms,
    MdWms
  }
}
</script>

<style lang="scss" scoped>
// 移动
@media only screen and (max-width: 750px) {
  .newsMain{
    .PC{
      display: none;
    }
  }

}
// PC端/
@media only screen and (min-width: 756px) {
  .newsMain{
    .MD{
      display: none;
    }
  }
}
</style>
